import React, { useState, useEffect, createContext } from "react";

const defaultState = {
  clientView: true,
};

const UserContext = createContext(defaultState);

export default UserContext;
